import { useTheme } from "@mui/material";
import CLink from "components/CLink";
import { usePrivateLabel } from "context/PrivateLabelContext/UsePrivateLabelContextProvider";
import { useState } from "react";

const CContactusButton: React.FC<
  {
    pathname?: string;
    handleClick?: () => void;
    contactUsLink?: string;
    sx?: React.CSSProperties & {
      "&:hover"?: React.CSSProperties;
    };
  } & {
    fontSize?: string | { md?: string; xs?: string };
    color?: string | { md?: string; xs?: string };
    textDecoration?: string;
    display?: string;
  }
> = ({ pathname, handleClick, contactUsLink, sx }) => {
  const isSelected = pathname === "/contactus";
  const theme = useTheme();
  const privateLabel = usePrivateLabel();
  const isNFTYDoor = privateLabel?.privateLabel?.isNFTYDoor;
  const [isHovered, setIsHovered] = useState(false);

  const handleContactClick = () => {
    window.dispatchEvent(new Event("open-chat"));
  };

  const isMobile = window.innerWidth <= 768;

  const hoverStyles = sx?.["&:hover"] || {};
  const baseStyles = { ...sx };
  delete baseStyles["&:hover"];

  return !isNFTYDoor ? (
    <CLink
      target="_blank"
      handleClick={handleClick}
      to={contactUsLink ?? "/contactus"}
      sx={{
        fontSize: { md: "1.4rem", xs: "2.4rem" },
        color: {
          md: isSelected
            ? theme.palette.primary.main
            : theme.palette.text.primary,
          xs: theme.palette.background.paper,
        },
      }}
    >
      Contact us
    </CLink>
  ) : (
    <span
      onClick={handleContactClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        fontFamily: "Pro Display Regular",
        cursor: "pointer",
        padding: 0,
        border: "none",
        background: "transparent",
        textDecoration: "none",
        display: "inline",
        fontSize: isMobile ? "2.4rem" : "1.4rem",

        color: isMobile
          ? theme.palette.background.paper
          : theme.palette.text.primary,

        ...baseStyles,
        ...(isHovered && hoverStyles),
      }}
    >
      Contact us
    </span>
  );
};

export default CContactusButton;
